export const mapBooleanToString = (value: boolean): string => (value ? 'Yes' : 'No');
